import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import logoWhite from './assets/logo_white.png';
import rcLogo from './assets/rclogo.svg';
import rcaicLogo from './assets/RCAIC_Logo.png';
import magSilhouette from './assets/A4 Floating Magazine Mockupdsds.png';
import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const COVER_SRC = '/Front%20Cover.png';
const MAX_PROGRESS = 6; 

export default function App() {
  const [progress, setProgress] = useState(0); 
  const [isDesktop, setIsDesktop] = useState(typeof window !== 'undefined' ? window.innerWidth >= 1024 : true);
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const touchStartRef = useRef(null);
  const coverRef = useRef(null);
  const textareaRef = useRef(null);

  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    // Improve touch responsiveness on mobile by using a smaller divisor
    // and adding a simple "fling" behavior on touchend.
    let touchState = { lastY: 0, lastTime: 0, velocity: 0 };
    const getDivisor = () => (isDesktop ? 1600 : 300);

    const onWheel = (e) => {
      e.preventDefault();
      const delta = e.deltaY;

      setProgress((p) => {
        const n = Math.max(0, Math.min(MAX_PROGRESS, p + delta / getDivisor()));
        return n;
      });
    };

    const onKey = (e) => {
      // Don't intercept keys when typing in form inputs
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
        return;
      }

      if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') {
        e.preventDefault();

        setProgress((p) => Math.min(MAX_PROGRESS, p + 0.06));
      } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
        e.preventDefault();
        setProgress((p) => Math.max(0, p - 0.06));
      }
    };

    const onTouchStart = (e) => {
      const y = e.touches[0].clientY;
      touchState.lastY = y;
      touchState.lastTime = Date.now();
      touchState.velocity = 0;
    };

    const onTouchMove = (e) => {
      const y = e.touches[0].clientY;
      const now = Date.now();
      const dy = touchState.lastY - y;
      const dt = Math.max(1, now - touchState.lastTime);
      const velocity = dy / dt; // px per ms
      touchState.velocity = velocity;

      setProgress((p) => {
        const n = Math.max(0, Math.min(MAX_PROGRESS, p + dy / getDivisor()));
        return n;
      });

      touchState.lastY = y;
      touchState.lastTime = now;
    };

    const onTouchEnd = () => {
      // If the user swiped quickly, apply a small jump (fling)
      const vel = touchState.velocity;
      if (Math.abs(vel) > 0.5) {
        setProgress((p) => Math.max(0, Math.min(MAX_PROGRESS, p + Math.sign(vel) * 0.8)));
      }
      touchState = { lastY: 0, lastTime: 0, velocity: 0 };
    };

    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('keydown', onKey, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: false });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: false });

    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
      document.body.style.overflow = '';
    };
  }, [isDesktop]);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Auto-expand textarea
    if (name === 'message' && textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 400) + 'px';
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim() || !formData.email.trim() || !formData.message.trim()) {
      setSubmitStatus('error');
      return;
    }

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'feedback'), {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        timestamp: serverTimestamp(),
        userAgent: navigator.userAgent
      });
      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setSubmitStatus(null), 3000);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

    const mainProgress = Math.min(1, progress); 

  const startTop = 100; 
  const midTop = 94; 
  const endTop = 50; 

  
  const pSplit = (startTop - midTop) / (startTop - endTop);

  
  let top;
  if (mainProgress <= pSplit) {
    const local = mainProgress / pSplit; 
    top = startTop - local * (startTop - midTop);
  } else {
    const local = (mainProgress - pSplit) / (1 - pSplit); 
    top = midTop - local * (midTop - endTop);
  }

  const scale = 1.8 - 0.8 * mainProgress;
  const coverOpacity = Math.min(1, mainProgress * 1.1);
  
  const logoOpacity = Math.max(0, 1 - mainProgress / pSplit);

  
  const coverPhase = Math.max(0, Math.min(1, progress - 1)); 
  
  const extraPause = 0.25; 
  const coverPhaseEffective = coverPhase <= extraPause ? 0 : (coverPhase - extraPause) / (1 - extraPause); 

  
  const maxTranslateX = 18; 
  
  const extraOffsetPx = isDesktop ? Math.round(coverPhaseEffective * 200) : 0; 

  
  const gapPx = 50; 
  const vwPx = typeof window !== 'undefined' ? window.innerWidth : 1024;

  
  
  const coverWidth = coverRef && coverRef.current ? coverRef.current.getBoundingClientRect().width : Math.min(vwPx * 0.9, vwPx * 0.6);
  const maxTranslatePxByGap = Math.max(0, Math.floor(vwPx / 2 - gapPx - coverWidth / 2));

  
  const pxFromVW = isDesktop ? Math.round(coverPhaseEffective * (maxTranslateX * vwPx / 100)) + extraOffsetPx : 0;
  
  const finalTranslatePx = Math.max(0, Math.min(pxFromVW, maxTranslatePxByGap));

  
  const extraTranslateX = finalTranslatePx;

  
  const appearThreshold = 0.98;
  const aboutVisible = coverPhaseEffective >= appearThreshold || coverPhase >= 1; 

  
  const circlePhase = Math.max(0, Math.min(1, progress - 2)); 
  
  const circleScale = 0.02 + circlePhase * 6.0; 
  const circleOpacity = Math.max(0, Math.min(1, circlePhase * 0.95));

  
  const panelPhase = Math.max(0, Math.min(1, progress - 3)); 
  
  const autoFillStart = 0.7;
  const accel = 2.2; 
  let panelDisplayedPhase = panelPhase;
  if (panelPhase > autoFillStart) {
    panelDisplayedPhase = Math.min(1, autoFillStart + (panelPhase - autoFillStart) * accel);
  }
  
  const panelTranslateYPercent = 100 - panelDisplayedPhase * 100; 
  const panelOpacity = panelDisplayedPhase;
  const panelPointerEvents = panelDisplayedPhase > 0.02 ? 'auto' : 'none';
  
  const panelBgAlpha = 1;

  
  const hideThreshold = 0.4; 
  const contentVisibilityFactor = Math.max(0, 1 - panelPhase / hideThreshold); 

  
  const finalCoverOpacity = ((!isDesktop && coverPhaseEffective > 0) ? Math.max(0, 1 - coverPhaseEffective * 2) : coverOpacity) * contentVisibilityFactor;
  const finalLogoOpacity = logoOpacity * contentVisibilityFactor;
  const finalAboutOpacity = (aboutVisible ? 1 : 0) * contentVisibilityFactor;

  
  
  const rawRcaicPhase = Math.max(0, Math.min(1, progress - 4));
  
  const rcaicCirclePhase = panelDisplayedPhase >= 1 ? rawRcaicPhase : 0;
  const rcaicCircleScale = 0.02 + rcaicCirclePhase * 8.0;
  const rcaicCircleOpacity = rcaicCirclePhase;
  
  const rcaicPanelOpacity = panelOpacity * (1 - rcaicCirclePhase);
  const rcaicPanelPointerEvents = rcaicPanelOpacity > 0.02 ? 'auto' : 'none';
  
  const panelFadeThreshold = 0.98;
  const topicsOpacity = rcaicCirclePhase > panelFadeThreshold ? Math.max(0, (rcaicCirclePhase - panelFadeThreshold) / (1 - panelFadeThreshold)) : 0;
  
  const topicsTranslateY = 12 - topicsOpacity * 12; 

  
  const rawFinalPhase = Math.max(0, Math.min(1, progress - 5));
  
  const finalCirclePhase = topicsOpacity >= 1 ? rawFinalPhase : 0;
  const finalCircleScale = 0.02 + finalCirclePhase * 10.0;
  const finalCircleOpacity = finalCirclePhase;

  

  const finalTopicsFadeStart = 0.98; 
  let effectiveTopicsOpacity = topicsOpacity;
  if (finalCirclePhase > finalTopicsFadeStart) {
    const local = (finalCirclePhase - finalTopicsFadeStart) / (1 - finalTopicsFadeStart); 
    effectiveTopicsOpacity = Math.max(0, topicsOpacity * (1 - local));
  }

  const feedbackThreshold = 0.98;
  const feedbackOpacity = finalCirclePhase > feedbackThreshold ? Math.max(0, (finalCirclePhase - feedbackThreshold) / (1 - feedbackThreshold)) : 0;
  const feedbackTranslateY = 12 - feedbackOpacity * 12; 

  
  const scrollHintOpacity = Math.max(0, 1 - progress * 8);

  
  const coverInFront = mainProgress >= pSplit;
  return (
    <div className="landing" aria-hidden={false}>
      <div className="landing-brand" style={{ zIndex: coverInFront ? 20 : 40 }}>
        <div className="landing-top-logos" style={{ opacity: finalLogoOpacity }}>
          
          <img src={rcLogo} alt="RC Crest" className="landing-top-logo crest" />
          <img src={rcaicLogo} alt="RCAIC" className="landing-top-logo rcaic" />
        </div>

        <img
          src={logoWhite}
          alt="Synapse"
          className="landing-logo"
          style={{ opacity: finalLogoOpacity }}
        />
      </div>

      <img
        ref={coverRef}
        src={COVER_SRC}
        alt="Magazine cover"
        className="landing-cover"
        style={{ top: `${top}vh`, left: '50%', transform: `translate(-50%, -50%) translateX(${extraTranslateX}px) scale(${scale})`, opacity: finalCoverOpacity, zIndex: coverInFront ? 40 : 10 }}
      />

      {}
      <aside className={`about-panel ${aboutVisible ? 'visible' : ''}`} style={{ opacity: finalAboutOpacity, transform: isDesktop ? (aboutVisible ? 'translateX(0)' : 'translateX(24px)') : (aboutVisible ? 'translateX(0)' : 'translateY(12px)'), width: isDesktop ? '50%' : '100%', pointerEvents: (aboutVisible ? 'auto' : 'none') }}>
        <div className="about-inner">
          <h3>ABOUT SYNAPSE</h3>
          <p>
            Synapse is the official magazine of the AI Club, designed to showcase the rapidly evolving world of artificial intelligence through a student-driven perspective. It serves as a platform for sharing knowledge, ideas, projects, and opinions related to AI, technology, and innovation. From beginner-friendly concepts to real-world applications and ethical discussions, Synapse encourages curiosity, critical thinking, and creativity. Just like a synapse connects neurons to enable communication, this magazine connects students, ideas, and technology to inspire the next generation of innovators.          </p>
          <div className="about-btn-group">
            <Link to="/flipbook" className="about-read-btn btn-ghost">Read</Link>
            <a href="/Synapse.pdf" download className="about-download-btn btn-ghost" aria-label="Download Synapse PDF">Download</a>
          </div>
        </div>
      </aside>

      {}
      <div
        className="landing-circle"
        aria-hidden="true"
        style={{
          transform: `translate(-50%, -50%) scale(${circleScale})`,
          opacity: circleOpacity,
          zIndex: 5,
          pointerEvents: 'none'
        }}
      />

      {}
      <aside
        className={`rcaic-panel ${panelDisplayedPhase > 0.02 ? 'visible' : ''}`}
        aria-hidden={rcaicPanelOpacity === 0}
        style={{
          transform: `translate(-50%, ${panelTranslateYPercent}%)`,
          opacity: rcaicPanelOpacity,
          background: `rgba(0,0,0,${panelBgAlpha})`,
          zIndex: 260,
          pointerEvents: rcaicPanelPointerEvents
        }}
      >
        <div className="rcaic-inner">
          <img src={rcaicLogo} alt="RCAIC Logo" className="rcaic-logo" />
          <h3>ABOUT RCAIC</h3>
          <p>
            The Royal College Artificial Intelligence Club (RCAIC) is a dynamic community of young innovators dedicated to exploring and implementing cutting-edge AI technologies. The club focuses on key innovation areas such as machine learning, computer vision, natural language processing, and robotics and automation, while fostering a strong community through collaborative learning, project-based exploration, and mentorship. RCAIC also emphasizes hands-on learning with workshops, practical AI projects, competition training, and sessions led by industry experts, helping members build skills, experience, and lifelong connections.
          </p>
          <a href="#" className="rcaic-visit btn-ghost" target="_blank" rel="noreferrer">Visit RCAIC</a>
        </div>
      </aside>

      {}
      <div
        className="rcaic-circle-2"
        aria-hidden="true"
        style={{
          transform: `translate(-50%, -50%) scale(${rcaicCircleScale})`,
          opacity: rcaicCircleOpacity,
          zIndex: 300,
          pointerEvents: 'none'
        }}
      />

      {}
      <section
        className="featured-topics"
        aria-hidden={effectiveTopicsOpacity === 0}
        style={{
          opacity: effectiveTopicsOpacity,
          
          zIndex: 2000,
          pointerEvents: effectiveTopicsOpacity > 0.02 ? 'auto' : 'none'
        }}
      >
        <div className="featured-inner">
          <h3>FEATURED TOPICS</h3>
          <div className="topics-grid">
            {[
              'The Rise of Intelligent Systems',
              'AI in Science, Space & the Planet',
              'Technology Reshaping Human Life',
              'Ethics, Power & Responsibility in AI',
              'The Future of Creativity & Expression',
              'AI-Driven Security & Digital Trust',
              'Next-Gen Computing & Emerging Paradigms',
              'When Machines Start Reflecting Us'
            ].map((t, i) => (
              <div className="topic-card" key={i}>
                <div className="mac-dots">
                  <span className="dot close" />
                  <span className="dot minimize" />
                  <span className="dot maximize" />
                </div>
                <div className="topic-title">{t}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {}
      <div
        className="final-circle"
        aria-hidden="true"
        style={{
          transform: `translate(-50%, -50%) scale(${finalCircleScale})`,
          opacity: finalCircleOpacity,
          zIndex: 2200,
          pointerEvents: 'none'
        }}
      />

      {}
      <section
        className="feedback-section"
        aria-hidden={feedbackOpacity === 0}
        style={{
          opacity: feedbackOpacity,
          zIndex: 2400,
          pointerEvents: feedbackOpacity > 0.02 ? 'auto' : 'none'
        }}
      >
        <div className="feedback-inner">
          <img src={magSilhouette} alt="" className="feedback-silhouette" />
          <h3>WE'D LOVE YOUR FEEDBACK</h3>
          <form className="feedback-form" onSubmit={handleFormSubmit}>
            <input 
              name="name" 
              placeholder="Your name"
              value={formData.name}
              onChange={handleFormChange}
              disabled={isSubmitting}
            />
            <input 
              name="email" 
              placeholder="Your email"
              type="email"
              value={formData.email}
              onChange={handleFormChange}
              disabled={isSubmitting}
            />
            <textarea 
              ref={textareaRef}
              name="message" 
              placeholder="Your message" 
              rows={6}
              value={formData.message}
              onChange={handleFormChange}
              disabled={isSubmitting}
            />
            <button 
              type="submit" 
              className="btn-ghost"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Feedback'}
            </button>
            {submitStatus === 'success' && <p className="feedback-success">Thank you! Feedback sent successfully.</p>}
            {submitStatus === 'error' && <p className="feedback-error">Please fill in all fields and try again.</p>}
          </form>
        </div>
      </section>

      <div className="glass-island glass-left" aria-hidden={feedbackOpacity === 0} style={{ opacity: feedbackOpacity, zIndex: 2600 }}>
        <div className="glass-inner">
          <span className="copyright-symbol">©</span>
          <span className="synapse-year">SYNAPSE '25</span>
        </div>
      </div>

      <div className="glass-island" aria-hidden={feedbackOpacity === 0} style={{ opacity: feedbackOpacity, zIndex: 2600 }}>
        <div className="glass-inner">
          <a href="https://www.instagram.com/rcaic_official/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line></svg>
          </a>
          <a href="https://www.youtube.com/@RoyalCollegeAIClub" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"></path><path d="m10 15 5-3-5-3z"></path></svg>
          </a>
          <a href="https://rcaic.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Website">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>
          </a>
        </div>
      </div>

      <div className="landing-scroll-space" aria-hidden="true" />

      {}
      <div
        className="scroll-hint"
        aria-hidden={scrollHintOpacity === 0}
        style={{
          opacity: scrollHintOpacity,
          zIndex: 100,
          pointerEvents: 'none'
        }}
      >
        <span>Scroll down</span>
      </div>
    </div>
  );
}
